"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCreatedUpdatedFieldValue = exports.getCreatedUpdatedFieldEmptyValue = void 0;
const getCreatedUpdatedFieldEmptyValue = () => {
    return { by: null, on: "" };
};
exports.getCreatedUpdatedFieldEmptyValue = getCreatedUpdatedFieldEmptyValue;
const generateCreatedUpdatedFieldValue = (value) => {
    return { ...(0, exports.getCreatedUpdatedFieldEmptyValue)(), ...value };
};
exports.generateCreatedUpdatedFieldValue = generateCreatedUpdatedFieldValue;
